import styled from "styled-components";

export const CalendarBanner = styled.div`
    position: relative;

    .container {
        @media only screen and (min-width: 1024px) {
            margin: 0;
            width: 50%;
            height: 100%;
        }
        @media only screen and (min-width: 1280px) {
            padding-left: 1.5rem;
            padding-right: 1.5rem;
        }
        @media only screen and (min-width: 1440px) {
            padding-left: 3rem;
            padding-right: 3rem;
        }
    }

    .calendar-month-button {
        display: flex !important;
    }

    .calendar-banner__wrap {
        .text-wrap, 
        .container {
            position: initial;
            z-index:1;
        }

        .btn {
            position: absolute; 
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            opacity: 0;
        }
    }

    .calendar-banner__btn-see-all {
        background-color: white;
        border-color: var(--color-gray-60);
        color: var(--color-gray-60);
        position: absolute;
        right: 16px;
        top: 28px;
        margin: 0;
        min-width: 0;
        z-index: 99;

        @media only screen and (min-width: 768px) {
            right: 32px;
        }

        @media only screen and (min-width: 1280px) {
            top: 46px;
        }

        @media only screen and (min-width: 1920px) {
            right: 48px;
        }

        &:hover {
            box-shadow: var(--shadow-inner);
            border-color: var(--color-black, black);
            color: white;

            &:before {
                background-color: var(--color-black, black);
            }
        }
    }
`;

export const CalendarBannerBg = styled.div`
    position: -webkit-sticky; // Required for Safari
    position: sticky;
    left: 0;
    top: 0;
    height: 100vh;
    width: 100%;

    //Banner overrides
    .calendar-banner__wrap {
        position: relative;
        height: 75%;
        overflow: hidden;

        > section {
            height: 100%;
        }

        @media only screen and (min-width: 1024px) {
            height: 100%;
        }
    }
`;

export const CalendarBannerContent = styled.div`
    background-color: white;
    padding: 1rem;
    position: relative;
    margin-top: -25vh;
    z-index: 0;

    @media only screen and (min-width: 768px) {
        padding: 1rem 2rem;
    }

    @media only screen and (min-width: 1024px) {
        margin-top: -50vh;
        margin-left: 50%;
        min-height: 60vh;
        width: 50%;
        z-index: 98;
    }

    @media only screen and (min-width: 1280px) {
        padding: 1rem 2rem 2rem 2rem;
    }

    @media only screen and (min-width: 1920px) {
        padding: 1rem 3rem 2rem 3rem;
    }

`;

export const CalendarBannerScrollBtn = styled.button`
    width: 40px;
    height: 40px;
    border-radius: 100%;
    background-color: black;
    color: white;
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
    position: absolute;
    left: 50%;
    top: 0;
    transform: translate3d(-20px, -20px, 0);
    z-index: 99;
    pointer-events: none; //remove if added functionality
    overflow: hidden;

    &:focus {
        outline: none;
    }

    @keyframes scroll {
        0% {
            clip-path: inset(0 0 8px 0);
            opacity: .5;
        }
        100% {
            clip-path: inset(0 0 0 0);
            opacity: 1;
        }
    }

    &:before {
        content:"";
        height: 10px;
        width: 2px;
        background-color: white;
        animation-duration: 1.5s;
        animation-iteration-count: infinite;
        animation-name: scroll;
    }
`;